/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.login").
controller("DxLoginRouteController", function LoginRouteController(
	$scope,
	$location,
	$window,

	DX_URLS,
	faults,
	dxRegion,
	dxDialog,
	dxLocalize
) {
	"use strict";

	$scope.Urls = DX_URLS;

	$scope.displaySkolonButton = dxRegion.getCurrent().key === "Europe" ||
		dxRegion.getCurrent().key === "Development";

	$scope.$on("auth:loginsuccess", function onAuthLoginSuccess() {
		var searchObject = $location.search();
		if (searchObject.return_to) {
			$location.url(searchObject.return_to);
		} else {
			$location.url(DX_URLS.get("overview"));
		}
	});

	$scope.$on("auth:loginfailed", function onAuthLoginFailed(event, errors, statusCode, email) {
		var message;
		var title;

		if (errors && errors.indexOf(faults.INVALID_CREDENTIALS) >= 0) {
			title = dxLocalize.get("LoginFailed");
			message = dxLocalize.get("LoginFailedDescription");
		}

		if (errors && errors.indexOf(faults.USER_DISABLED) >= 0) {
			title = "User is disabled";
			message = "Contact Digiexam for more information.";
		}

		if (errors && errors.indexOf(faults.TOO_MANY_REQUESTS) >= 0) {
			title = dxLocalize.get("LoginFailed");
			message = dxLocalize.get("LoginFailedDescription.Throttled");
		}

		if (errors && errors.indexOf(faults.USER_WRONG_REGION) >= 0) {
			var serverName = "";
			if (dxRegion.getCurrent().key === "USA") {
				serverName = dxLocalize.get("Login.Europe");
			} else {
				serverName = "USA";
			}

			dxDialog.alert({
				title: dxLocalize.get("Login.UserWrongRegionPopupTitle"),
				body: dxLocalize.get("Login.UserWrongRegionPopupBody").format(serverName),
				acceptText: dxLocalize.get("Login.TryAgain"),
				acceptCallback: function acceptCallback() {
					changeRegion(email);
				},
				escapeToClose: false,
				clickOutsideToClose: false,
			});

			return;
		}

		if (statusCode === 0) {
			title = dxLocalize.get("LoginFailed");
			message = dxLocalize.get("LoginFailedDescription.Timeout");
		}

		if (!title || !message) {
			title = dxLocalize.get("LoginFailed");
			message = dxLocalize.get("UnknownErrorTryAgain");
		}

		dxDialog.alert({
			title: title,
			body: message,
			acceptText: dxLocalize.get("Ok"),
		});
	});

	$scope.redirectToSkolon = function redirectToSkolon() {
		$scope.skolonButtonClicked = true;
		$window.location.href = "/api/v1/skolon/loginredirect";
	};

	function changeRegion(email) {
		if (dxRegion.getCurrent().key === dxRegion.regions[1].key) {
			dxRegion.setSelected(dxRegion.regions[0]);
			dxRegion.redirectTo(dxRegion.regions[0], {email: email});
		} else {
			dxRegion.setSelected(dxRegion.regions[1]);
			dxRegion.redirectTo(dxRegion.regions[1], {email: email});
		}
	}
});
